import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Col, Row } from '@thd-olt-component-react/grid';
import { initSurvey } from '../qualtricsHelper';
import './search-feedback.scss';

const SearchFeedback = (props) => {
  const { channel } = useContext(ExperienceContext);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('search-feedback.ready');
    initSurvey();
  }, []);

  if (channel === 'mobile') return null;

  const { type } = props;

  return (
    <Row className={type === 'collection' ? 'collectionFeedbackWrapper' : ''}>
      <Col className="search-feedback-wrapper">
        <div id={`${type}Feedback`} />
      </Col>
    </Row>
  );
};

SearchFeedback.displayName = 'SearchFeedback';

SearchFeedback.propTypes = {
  type: PropTypes.oneOf([
    'search',
    'collection'
  ])
};

SearchFeedback.defaultProps = {
  type: 'search',
};

export { SearchFeedback };
